// extracted by mini-css-extract-plugin
module.exports = {"text":"RevealText_text__CTfUc","textWrapper":"RevealText_textWrapper__EcuQY","wordsWrapper":"RevealText_wordsWrapper__oQfMK"};